export default [
    {
        id: 1,
        title: "Greek Salad",
        price: 12.99,
        coverImg : "greek.jpg",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
        actionPoint: "Order a delivery",
    },
    {
        id: 2,
        title: "Brochette",
        price: 12.99,
        coverImg : "brochettes.jpg",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
        actionPoint: "Order a delivery",
    },
    {
        id: 3,
        title: "Lemon Desert",
        price: 12.99,
        coverImg : "lemon-dessert.jpg",
        description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor.",
        actionPoint: "Order a delivery",
    }
]